export default "__VITE_ASSET__8ab17967__"